<app-landing></app-landing>
<app-home></app-home>
<app-rooms></app-rooms>
<app-location></app-location>
<app-contact></app-contact>